import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { BASE_PATH } from 'src/app/backend';
import { environment } from 'src/environments/environment';


export function provideOpenAPI(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: BASE_PATH, useValue: environment.apiConfig.webApiUri },
    ]);
  }